import { Flex } from '@chakra-ui/react';
import { useDispatch } from 'react-redux';
import { useHistory, useLocation } from 'react-router-dom';

import { isMobileView } from 'constants/isMobileView';

import {
  BottomDrawer,
  DrawerBody,
  DrawerContent,
  DrawerHeader,
  primaryDrawerWidth,
  secondaryDrawerWidth,
} from 'uiToolkitV1/BottomDrawer';

import { CreateViolationPrimaryPanel } from './components/CreateViolationPrimaryPanel';
import { MeshMavenPanel } from './components/MeshMavenPanel';
import { PastNotesPanel } from './components/PastNotesPanel';
import { ADD_VIOLATION_DRAWER_QUERY_KEY } from './constants';
import {
  initializeAddViolationDrawer,
  updateAddViolationDrawer,
  useSelectAddViolationDrawerData,
} from './slice/addViolation.slice';

const CreateViolationDrawer = () => {
  const { isSecondaryPanelOpen, isPastNotesPanelOpen } = useSelectAddViolationDrawerData();

  const dispatch = useDispatch();
  const history = useHistory();
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const isDrawerOpen = queryParams.get(ADD_VIOLATION_DRAWER_QUERY_KEY) === 'true';

  const onCloseDrawer = () => {
    queryParams.delete(ADD_VIOLATION_DRAWER_QUERY_KEY);
    history.push({
      search: queryParams.toString(),
    });
    dispatch(initializeAddViolationDrawer());
  };

  const onSecondaryPanelClose = () => {
    dispatch(
      updateAddViolationDrawer({
        isSecondaryPanelOpen: false,
      })
    );
  };

  const onPastNotesPanelClose = () => {
    dispatch(
      updateAddViolationDrawer({
        isPastNotesPanelOpen: false,
      })
    );
  };

  const mobileViewProps = isMobileView() ? { marginLeft: '0px', marginRight: '0px' } : {};

  return (
    <BottomDrawer isOpen={isDrawerOpen} onClose={onCloseDrawer}>
      <DrawerContent
        width={{
          base: '100%',
          md: isSecondaryPanelOpen ? `${primaryDrawerWidth + secondaryDrawerWidth}px` : `${primaryDrawerWidth}px`,
        }}
        {...mobileViewProps}
        className="mesh-app-drawer"
      >
        <DrawerHeader onClose={onCloseDrawer}>{null}</DrawerHeader>
        <DrawerBody p="4px" h="100%">
          <Flex h="100%">
            {/* 
              rendering when desktop site -> always
              rendering when mobile site -> only when secondary panel is closed
            */}
            {(!isMobileView() || (isMobileView() && !isSecondaryPanelOpen)) && !isPastNotesPanelOpen && (
              <CreateViolationPrimaryPanel onCloseDrawer={onCloseDrawer} />
            )}{' '}
            {isSecondaryPanelOpen && (
              <MeshMavenPanel onSecondaryPanelClose={onSecondaryPanelClose} onCancel={onSecondaryPanelClose} />
            )}
            {isPastNotesPanelOpen && <PastNotesPanel onBack={onPastNotesPanelClose} />}
          </Flex>
        </DrawerBody>
      </DrawerContent>
    </BottomDrawer>
  );
};

export { CreateViolationDrawer };
